import React from "react";
import * as ReactDOMClient from "react-dom/client";

import App from "./App";
import { Provider } from "react-redux";

import store from "./store/store";

import { PersistGate } from "redux-persist/integration/react";
import { persistStore } from "redux-persist";
import { BrowserRouter as Router } from "react-router-dom";
import "./index.scss";
console.log("before store import");
console.log("after store import");

let persistor = persistStore(store);

// Fix: Wrap JSX elements inside parentheses
ReactDOMClient.createRoot(document.getElementById("root")).render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <Router>
        <App />
      </Router>
    </PersistGate>
  </Provider>
);

// import React from 'react';
// import * as ReactDOMClient from 'react-dom/client';

// ReactDOMClient.createRoot(document.getElementById('root')).render(
//   <React.StrictMode>
//     <h1>Hello World!</h1>
//   </React.StrictMode>
// );
